var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUtilityPole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 32H480C471.164 32 464 39.162 464 48V80H432V48C432 39.162 424.836 32 416 32H400C391.164 32 384 39.162 384 48V80H280V16C280 7.162 272.836 0 264 0H248C239.164 0 232 7.162 232 16V80H128V48C128 39.162 120.836 32 112 32H96C87.164 32 80 39.162 80 48V80H48V48C48 39.162 40.836 32 32 32H16C7.164 32 0 39.162 0 48V96C0 113.672 14.326 128 32 128H68.734L232 236.844V512H280V236.844L443.266 128H480C497.674 128 512 113.672 512 96V48C512 39.162 504.836 32 496 32ZM155.268 128H232V179.156L155.268 128ZM280 128H356.734L280 179.156V128Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilityPole);
export default __webpack_public_path__ + "static/media/utility-pole.b39b87fe416bffcb5cc3b9110e3e5132.svg";
export { ForwardRef as ReactComponent };